<div class="navbar-area" [ngClass]="navbarClass" stickyClass="sticky-box-shadow">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
      <a class="navbar-brand" routerLink="/"><img [src]="wipperozLogo" alt="Wipperoz w logo" /></a>
      <button class="navbar-toggler" type="button" (click)="toggleClass()">
        <span class="burger-menu">
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link"
              ><span i18n-aria-label="@@homeLandingAriaLabel" i18n="@@homeLandingButton">Home</span>
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0)" class="nav-link dropdown-toggle"
              ><span i18n="@@aboutButton" i18n-aria-label="@@aboutAriaLabel">About Us</span
              ><i-feather name="chevron-down"></i-feather
            ></a>
            <ul class="dropdown-menu">
              <li class="nav-item">
                <a
                  routerLink="/about"
                  routerLinkActive="active"
                  [attr.aria-label]="aboutWipperozButtonAriaLabel"
                  i18n="@@aboutWipperozButton"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="nav-link"
                  >Wipperoz</a
                >
              </li>
              <li class="nav-item">
                <a
                  routerLink="/about/terms"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="nav-link"
                  [attr.aria-label]="termsButtonAriaLabel"
                  i18n="@@termsButton"
                  >Terms and Conditions</a
                >
              </li>
              <li class="nav-item">
                <a
                  routerLink="/about/privacy"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="nav-link"
                  [attr.aria-label]="privacyButtonAriaLabel"
                  i18n="@@privacyButton"
                  >Privacy Policy</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a
              routerLink="/pricing"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
              ><span i18n="@@pricingButton" i18n-aria-label="@@pricingAriaLabel">Pricing</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              routerLink="/press"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
              ><span i18n="@@pressButton" i18n-aria-label="@@pressAriaLabel">Press</span>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/blog" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link"
              ><span i18n="@@blogButton" i18n-aria-label="@@blogAriaLabel">Blog</span>
            </a>
          </li>
        </ul>
        <div class="others-option">
          <a [href]="helpLink" target="_blank" rel="nofollow" i18n="@@helpButton" class="btn btn-light">Help</a>
          <a i18n="@@loginButton" [href]="urlLogin" class="btn btn-primary">Login</a>
        </div>
      </div>
    </nav>
  </div>
</div>
